<template>
  <el-card shadow="never" class="reporting-content">
    <el-row :gutter="20">
      <el-col :span="8">
        <ul>
          <li><span class="text">Country For Tax Reporting:</span><span class="value">{{ countryForTaxRepName }}</span></li>
          <li><span class="text">Business Type:</span><span class="value">{{ businessTypeName }}</span></li>
          <li><span class="text">Method of Accounting:</span><span class="value">{{ methodOfAccountingName }}</span></li>
          <li><span class="text">Accounting Currency (Use Home Currency?):</span><span class="value">{{ accountingCurrencyHomeName }}</span></li>
          <li><span class="text">Select Accounting Base Currency:</span><span class="value">{{ currencyName }}</span></li>
          <li v-if="form.businessTypeId !== 1"><span class="text">Inventory Valuation Method:</span><span class="value">{{ inventoryValuationMethodName }}</span></li>
          <li><span class="text">Depreciation Method:</span><span class="value">{{ depreciationMethodName }}</span></li>
          <li><span class="text">Financial Year Time Period:</span><span class="value">{{ financialYearTimePeriodName }}</span></li>
          <li><span class="text">Financial Year Start Date:</span><span class="value">{{ form.financialYearStartDate }}</span></li>
          <li><span class="text">Business Employs People:</span><span class="value">{{ businessEmploysPeopleName }}</span></li>
          <li v-if="form.businessEmploysPeopleId === 1"><span class="text">Do you want to add a Payroll Journal?:</span><span class="value">{{ payrollJournalName }}</span></li>
        </ul>
      </el-col>
      <el-col :span="8">
        <ul>
          <li><span class="text">Business Formation:</span><span class="value">{{ businessFormationName }}</span></li>
          <li><span class="text">Default Chart of Accounts:</span><span class="value">{{businessTypeName}} / {{methodOfAccountingName}} / {{businessFormationName}}</span></li>
        </ul>

        <h5>Journals Used</h5>

        <div class="used">
          <div>SJ - Sales Journal</div>
          <div>
            <el-tag v-if="form.methodOfAccountingId === 2" type="success" style="width: 70px; text-align: center;">Active</el-tag>
            <el-tag v-else type="danger" style="width: 70px; text-align: center;">Inactive</el-tag>
          </div>
        </div>

        <div class="used">
          <div>PJ - Purchase Journal</div>
          <div>
            <el-tag v-if="form.methodOfAccountingId === 2" type="success" style="width: 70px; text-align: center;">Active</el-tag>
            <el-tag v-else type="danger" style="width: 70px; text-align: center;">Inactive</el-tag>
          </div>
        </div>

        <div class="used">
          <div>CR - Cash Receipts Journal</div>
          <div>
            <el-tag v-if="form.methodOfAccountingId === 2 || form.methodOfAccountingId === 1" type="success" style="width: 70px; text-align: center;">Active</el-tag>
            <el-tag v-else type="danger" style="width: 70px; text-align: center;">Inactive</el-tag>
          </div>
        </div>

        <div class="used">
          <div>CD - Cash Disbursements Journal</div>
          <div>
            <el-tag v-if="form.methodOfAccountingId === 2 || form.methodOfAccountingId === 1" type="success" style="width: 70px; text-align: center;">Active</el-tag>
            <el-tag v-else type="danger" style="width: 70px; text-align: center;">Inactive</el-tag>
          </div>
        </div>

        <div class="used">
          <div>SR - Sales Returns Journal</div>
          <div>
            <el-tag v-if="form.methodOfAccountingId === 2 && form.countryForTaxRepId !== 103" type="success" style="width: 70px; text-align: center;">Active</el-tag>
            <el-tag v-else type="danger" style="width: 70px; text-align: center;">Inactive</el-tag>
          </div>
        </div>

        <div class="used">
          <div>PR - Purchase Returns Journal</div>
          <div>
            <el-tag v-if="form.methodOfAccountingId === 2 && form.countryForTaxRepId !== 103" type="success" style="width: 70px; text-align: center;">Active</el-tag>
            <el-tag v-else type="danger" style="width: 70px; text-align: center;">Inactive</el-tag>
          </div>
        </div>

        <div class="used">
          <div>GJ - General Journal</div>
          <div>
            <el-tag v-if="form.methodOfAccountingId === 2 || form.methodOfAccountingId === 1" type="success" style="width: 70px; text-align: center;">Active</el-tag>
            <el-tag v-else type="danger" style="width: 70px; text-align: center;">Inactive</el-tag>
          </div>
        </div>

        <div class="used">
          <div>PR - Payroll Journal</div>
          <div><el-tag :type="form.payrollJournalId === 1 ? 'success' : 'danger'" style="width: 70px; text-align: center;">{{form.payrollJournalId === 1 ? 'Active' : 'Inactive'}}</el-tag></div>
        </div>

      </el-col>
      <el-col :span="8" v-if="form.isAddress">
        <ul>
          <li><span class="text">Address Line 1:</span><span class="value">{{ form.address }}</span></li>
          <li><span class="text">Address Line 2:</span><span class="value">{{form.address2}}</span></li>
          <li><span class="text">Address Line 3:</span><span class="value">{{ form.address3 }}</span></li>
          <li><span class="text">City:</span><span class="value">{{ cityName }}</span></li>
          <li><span class="text">State / Province / Country:</span><span class="value">{{ stateName }}</span></li>
          <li><span class="text">Post Code:</span><span class="value">{{ form.postCode }}</span></li>
          <li><span class="text">Country:</span><span class="value">{{ countryName }}</span></li>
        </ul>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import axios from "axios";
import moment from 'moment'
// import {viewEditFileMixin} from "@/mixins/viewEditFileMixin";
// import Media from '@dongido/vue-viaudio'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue';

export default {
  name: "TaxationContent",
  // mixins: [viewEditFileMixin],
  components: {
    // Media,
    SweetModal
  },
  data() {
    return {
      moment: moment,
      businessTypeName: null,
      methodOfAccountingName: null,
      businessFormationName: null,

      cityName: null,
      stateName: null,
      countryName: null,

      countryForTaxRepList: [],
      currencyList: [],
      businessTypeList: [],
      businessFormationList: [],
      methodOfAccountingList: [{id: 1, name: 'Cash', description: 'Tax Reporting Country Home Currency'}, {id: 2, name: 'Accrual', description: 'Tax Reporting Country Home Currency'}],
      accountingCurrencyHomeList: [{id: 1, name: 'Yes'}, {id: 2, name: 'No'}],
      inventoryValuationMethodList: [{id: 1, name: ' Weighted Average (AVCO)'}, {id: 2, name: 'First In/First Out (FIFO)'}, {id: 3, name: 'Last In/First Out (LIFO)'}],
      depreciationMethodList: [{id: 1, name: 'Straight Line'}],
      financialYearTimePeriodList: [{id: 1, name: ' Fiscal Year'}, {id: 2, name: 'Calendar Year'}],
      businessEmploysPeopleList: [{id: 1, name: 'Yes'}, {id: 2, name: 'No'}],
      payrollJournalList: [{id: 1, name: 'Yes'}, {id: 2, name: 'No'}],

      countryList: [],
      stateList: [],
      cityList: [],

      isForm: false,
      selectedBusinessTypeId: null,
      form: {
        countryForTaxRepId: null,
        businessTypeId: null,
        businessTypeDesc: '',
        methodOfAccountingId: null,
        methodOfAccountingDesc: '',
        accountingCurrencyHomeId: null,
        currencyId: null,
        inventoryValuationMethodId: null,
        depreciationMethodId: null,
        financialYearTimePeriodId: null,
        financialYearStartDate: null,
        businessEmploysPeopleId: null,
        payrollJournalId: null,
        businessFormationId: null,

        isAddress: false,
        countryId: null,
        stateId: null,
        cityId: null,
        postCode: '',
        address: '',
        address2: '',
        address3: '',
      },
    }
  },
  computed: {
    countryForTaxRepName() {
      const item = this.countryForTaxRepList.find(val => val.id === this.form.countryForTaxRepId)
      return item ? item.name : null
    },
    accountingCurrencyHomeName() {
      const item = this.accountingCurrencyHomeList.find(val => val.id === this.form.accountingCurrencyHomeId)
      return item ? item.name : null
    },
    currencyName() {
      const item = this.currencyList.find(val => val.id === this.form.currencyId)
      return item ? item.code : null
    },
    inventoryValuationMethodName() {
      const item = this.inventoryValuationMethodList.find(val => val.id === this.form.inventoryValuationMethodId)
      return item ? item.name : null
    },
    depreciationMethodName() {
      const item = this.depreciationMethodList.find(val => val.id === this.form.depreciationMethodId)
      return item ? item.name : null
    },
    financialYearTimePeriodName() {
      const item = this.financialYearTimePeriodList.find(val => val.id === this.form.financialYearTimePeriodId)
      return item ? item.name : null
    },
    businessEmploysPeopleName() {
      const item = this.businessEmploysPeopleList.find(val => val.id === this.form.businessEmploysPeopleId)
      return item ? item.name : null
    },
    payrollJournalName() {
      const item = this.payrollJournalList.find(val => val.id === this.form.payrollJournalId)
      return item ? item.name : null
    },
  },
  mounted() {
    this.directories()
  },
  methods: {
    async directories() {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companies/directories?companyId=${this.$route.query.companyId}&operation=update`)
        .then(response => {
          this.countryForTaxRepList = response.data.countryList
          this.businessTypeList = response.data.businessType
          this.businessFormationList = response.data.businessFormation
          this.currencyList = response.data.currencyList
          this.getAccounting()
        })
        .catch(error => {
          console.log('An error occurred:', error);
        });
    },
    getAccounting(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/company-accounting-and-business-info/item?companyId=${this.$route.query.companyId}`)
        .then(response => {
          this.isForm = !!response.data.item
          if (this.isForm) {
            this.businessTypeName = this.businessTypeList.find(item => item.id === response.data.item.businessTypeId).name
            this.methodOfAccountingName = this.methodOfAccountingList.find(item => item.id === response.data.item.methodOfAccountingId).name
            this.businessFormationName = this.businessFormationList.find(item => item.id === response.data.item.businessFormationId).name
          }
          this.selectedBusinessTypeId = response.data.item.businessTypeId
          this.form.countryForTaxRepId = response.data.item.countryForTaxRepId
          this.form.businessTypeId = response.data.item.businessTypeId
          this.form.businessTypeDesc = response.data.item.businessTypeDesc
          this.form.methodOfAccountingId = response.data.item.methodOfAccountingId
          this.form.methodOfAccountingDesc = response.data.item.methodOfAccountingDesc
          this.form.accountingCurrencyHomeId = response.data.item.accountingCurrencyHomeId
          this.form.currencyId = response.data.item.currencyId
          this.form.inventoryValuationMethodId = response.data.item.inventoryValuationMethodId
          this.form.depreciationMethodId = response.data.item.depreciationMethodId
          this.form.financialYearTimePeriodId = response.data.item.financialYearTimePeriodId
          this.form.financialYearStartDate = moment(response.data.item.financialYearStartDate, 'DD-MM-YYYY').format('DD MMM YYYY')
          this.form.businessEmploysPeopleId = response.data.item.businessEmploysPeopleId
          this.form.payrollJournalId = response.data.item.payrollJournalId
          this.form.businessFormationId = response.data.item.businessFormationId

          this.form.isAddress = response.data.item.isAddress ? response.data.item.isAddress : false
          if (this.form.isAddress) {
            this.countryList.push(response.data.item.country)
            this.stateList.push(response.data.item.state)
            this.cityList.push(response.data.item.city)
            this.form.countryId = response.data.item.countryId
            this.form.stateId = response.data.item.stateId
            this.form.cityId = response.data.item.cityId
            this.form.postCode = response.data.item.postCode
            this.form.address = response.data.item.address
            this.form.address2 = response.data.item.address2
            this.form.address3 = response.data.item.address3

            this.cityName = response.data.item.city.name
            this.stateName = response.data.item.state.name
            this.countryName = response.data.item.country.name
          }
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
  }
}
</script>

<style lang="scss" scoped>
.reporting-content {
  ul {
    margin-top: 20px;
    list-style: none;
    padding-left: 0;
    li {
      width: 100%;
      display: flex;
      align-items: center;
      margin: 10px 0;
      &:first-child {
        margin-top: 0;
      }
      .text {
        font-size: 18px;
        color: grey;
      }
      .value {
        margin-left: 10px;
      }
    }
  }
  .block-title {
    font-size: 18px;
    font-weight: bold;
  }
}

.used {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
</style>
